import {  PolarLine,   Text } from "./utils"
import {
  AnahtarliOtomatikSigorta,
  BulasikMak,
  CamasirMak,
  CihazBox,
  Firin,
  KacakAkim,
  Mak,
  PanoTali,
  Priz,
  Lamba,
  Anahtar,
  YuvarlakSolid
} from "./symbols"


// Sembol çizim Y pozisyonunu tanımla
const SYMBOL_DRAW_OFFSETS = {
  'light': -18 * 1,
  'socket': 0,
  'socketOven': -25 * 1,
  'socketDish': -25 * 1,
  'socketWash': -25 * 1,
  'socketCombi': -25 * 1,
  'socketAirCond': -25 * 1,
  'socketFan': -25 * 1,
  'socketMotor': -25 * 1,
  'socketHidrofor': -25 * 1,
  'mak': -25 * 1
};

// Text baseline offset'lerini tanımla - Her sembol için bağımsız
const TEXT_BASELINE_OFFSETS = {
  'light': {
    textStartOffset: -73 * 1,
    lineHeight: 15 * 1
  },
  'socket': {
    textStartOffset: -73 * 1,
    lineHeight: 15 * 1
  },
  'socketOven': {
    textStartOffset: -75 * 1,
    lineHeight: 15 * 1
  },
  'socketDish': {
    textStartOffset: -75 * 1,
    lineHeight: 15 * 1
  },
  'socketWash': {
    textStartOffset: -75 * 1,
    lineHeight: 15 * 1
  },
  'socketCombi': {
    textStartOffset: -75 * 1,
    lineHeight: 15 * 1
  },
  'socketAirCond': {
    textStartOffset: -75 * 1,
    lineHeight: 15 * 1
  },
  'socketFan': {
    textStartOffset: -75 * 1,
    lineHeight: 15 * 1
  },
  'socketMotor': {
    textStartOffset: -75 * 1,
    lineHeight: 15 * 1
  },
  'socketHidrofor': {
    textStartOffset: -75 * 1,
    lineHeight: 15 * 1
  },
  'mak': {
    textStartOffset: -75 * 1,
    lineHeight: 15 * 1
  }
};

// Sembol çizim pozisyonunu hesapla
function getSymbolDrawPosition(alignedBaselineY, symbolType, Scl) {
  const drawOffset = SYMBOL_DRAW_OFFSETS[symbolType] || 0;
  return alignedBaselineY + drawOffset * Scl;
}

// Bağımsız text pozisyonu hesaplama fonksiyonu
function getIndependentTextPositions(symbolBaselineY, symbolType, Scl) {
  const textConfig = TEXT_BASELINE_OFFSETS[symbolType] || TEXT_BASELINE_OFFSETS['socket'];

  const textStartY = symbolBaselineY + textConfig.textStartOffset * Scl;

  return {
    descY: textStartY,
    powerY: textStartY + textConfig.lineHeight * Scl
  };
}

// Faz sayısını hesaplayan fonksiyon
function calculatePhaseCount(basePhaseCount, hasNeutralBreaker) {
  return basePhaseCount + (hasNeutralBreaker ? 1 : 0);
}

// Benzersiz ID sayacı
let textIdCounter = 0;

// Sigorta bilgilerini çizen fonksiyon
function drawBreakerInfo(x, y, breakerData, Scl, options, isMainBreaker = false, branchIndex = 0, phaseCount = 1) {
  const result = [];
  const textHeight = 10 * Scl; // ✅ Kablo kesiti ile aynı boyut
   // Sigorta text'leri için seçenekler
  const breakerTextOptions = {
    ...options,
    colorIndex: 7,
    color: 0
  };

  if (isMainBreaker) {
    const startX = x + -15 * Scl;          // Ana sigorta yatay pozisyonu
    const startY = y + 5 * Scl;            // Ana sigorta dikey başlangıç pozisyonu
    const lineSpacing = 15 * Scl;          // Satırlar arası mesafe

    textIdCounter++;
    const curveText = breakerData.breaker1Curve || "B";
    const currentValue = breakerData.current || 40;
    const firstLineText = `${curveText}-${phaseCount}x${currentValue}A`;

    let text = {
      text: breakerData.text1,//firstLineText,
      x: startX,
      y: startY + 18,
      textHeight: textHeight,
      id: `breaker_line1_main_${textIdCounter}`
    };
    text.handle = text.id;
    result.push(Text(text.x, text.y, text, 0, breakerTextOptions));

    textIdCounter++;
     text = {
      text: breakerData.text2,//capacityText,
      x: startX + 7 * Scl,
      y: startY + -5 + lineSpacing,
      textHeight: textHeight,
      id: `breaker_line2_main_${textIdCounter}`
    };
    text.handle = text.id;
    result.push(Text(text.x, text.y, text, 0, breakerTextOptions));

  } else {
    const startX = x + 15 * Scl;           // Branch yatay pozisyonu  
    const textY = y + 3 * Scl;             // Branch dikey pozisyonu

    textIdCounter++;
    const curveText = breakerData.breaker1Curve || "B";
    const currentValue = breakerData.current || 16;
    const capacityValue = breakerData.shortCircuitCurCap || 6;

    const phasePrefix = phaseCount === 1 ? "" : `${phaseCount}x`;
    const fullBreakerText = `${curveText}-${phasePrefix}${currentValue}A-${capacityValue}kA`;

    let text = {
      text: fullBreakerText,
      x: startX,
      y: textY,
      textHeight: textHeight,
      id: `breaker_full_${branchIndex}_${textIdCounter}`
    };
    text.handle = text.id;
    result.push(Text(text.x, text.y, text, 0, breakerTextOptions));
  }

  return result;
}

// ZKT ve NKT koruma rölelerini çizen fonksiyon
function PanelNames(panelX, panelY, Scl, options, feeder) {
  const result = [];
  let textHeight = 12 * Scl;

  const startX = panelX - 230 * Scl;
  const startY = panelY - 40 * Scl;
  const lineSpacing = -18 * Scl;

  textIdCounter++;
  let text = {
    text: "Z.K.sasdasdT.",
    x: startX,
    y: startY,
    textHeight: textHeight,
    id: `zkt_text_${textIdCounter}`
  };
  text.handle = text.id;
 // result.push(Text(text.x, text.y, text, 0, options));

  if (feeder.panelNames) {
    if( feeder.panelNames.length > 1) {


    feeder.panelNames.forEach((name, index) => {

      text = {
        text: name,
        x: startX,
        y: startY + lineSpacing * index,
        textHeight: textHeight,
      };
      text.handle = text.id;
      result.push(Text(text.x, text.y, text, 0, options));
      
    })
    }else if(feeder.panelNames.length ===1){
      textHeight = 15 * Scl;
       text = {
        text: feeder.panelNames[0],
        x: startX+ 0*Scl,
        y: startY + lineSpacing   ,
        textHeight: textHeight,
      };
      text.handle = text.id;
      result.push(Text(text.x, text.y, text, 0, options));
    }
  }



  return result;
}


function drawMainPowerIndicator(panelX, panelY, Scl, options, feeder) {
  const result = [];
  const textHeight = 15 * Scl;
  let installedPower = "0";
  let demandPower = "0";

  if (feeder && feeder.installedPower) {
    installedPower = `${feeder.installedPower || 0}`;
    demandPower = `${feeder.demandPower || 0}`;
  }

  const tip3X = panelX + -200 * Scl;
  const tip3Y = panelY + -80 * Scl;
  const lineSpacing = -20 * Scl;

  textIdCounter++;
  let text = {
    text: `Kurulu Güç = ${installedPower} W`,
    x: tip3X,
    y: tip3Y,
    textHeight: textHeight,
    id: `tip3_main_${textIdCounter}`
  };
  text.handle = text.id;
  result.push(Text(text.x, text.y, text, 0, options));

  textIdCounter++;
  text = {
    text: `Talep Güç = ${demandPower} W`,
    x: tip3X,
    y: tip3Y + lineSpacing,
    textHeight: textHeight,
    id: `tip3_capacity_${textIdCounter}`
  };
  text.handle = text.id;
  result.push(Text(text.x, text.y, text, 0, options));

  return result;
}

function drawColumnSchemaInfo(data, panelX, panelY, Scl, options) {
  const result = [];
  const textHeight = 10 * Scl;
   // Feeder bilgileri
  if (data.feeder && data.feeder.components) {
    const components = data.feeder.components;
    const feederCableText = components[0]?.text || "5x6 mm² NYM";
    const breakerText1 = components[1]?.text1 || "C-3x40A ";
    const breakerText2 = components[1]?.text2 || "10kA";
    const rcdText1 = components[2]?.text1 || "40A 4P/300 mA";
    const rcdText2 = components[2]?.text2 || "(25-32)A";
    const rcdText3 = components[2]?.text3 || "K.A.K.R.";

    textIdCounter++;
    let text = {
      text:feederCableText,
      x: panelX - 300 * Scl,
      y: panelY - -10 * Scl,
      textHeight: textHeight,
      id: `feeder_cable_${textIdCounter}`
    };
    text.handle = text.id;
    result.push(Text(text.x, text.y, text, 0, options));



    // K.A.K.R. BİLGİLERİ
    const centerX = panelX - 100 * Scl;
    const lineSpacing = 15 * Scl;

    textIdCounter++;
    const line1Text = rcdText1;
    const line1Width = line1Text.length * textHeight * 0.5;
    text = {
      text: line1Text,
      x: centerX + 30 - line1Width / 2,
      y: panelY - -25 * Scl + lineSpacing,
      textHeight: textHeight,
      id: `feeder_kakr1_${textIdCounter}`
    };
    text.handle = text.id;
    result.push(Text(text.x, text.y, text, 0, options));

    textIdCounter++;
    const line2Text =rcdText2;
    const line2Width = line2Text.length * textHeight * 0.5;
    text = {
      text: line2Text,
      x: centerX + 35 - line2Width / 2,
      y: panelY - -15 * Scl + lineSpacing,
      textHeight: textHeight,
      id: `feeder_kakr2_${textIdCounter}`
    }; 
    text.handle = text.id;
    result.push(Text(text.x, text.y, text, 0, options));

/*     textIdCounter++;
    const line3Text =rcdText3;
    const line3Width = line3Text.length * textHeight * 0.5;
    text = {
      text: line3Text,
      x: centerX + 30 - line3Width / 2,
      y: panelY - -5 * Scl + lineSpacing,
      textHeight: textHeight,
      id: `feeder_kakr3_${textIdCounter}`
    }; */
    text.handle = text.id;
    result.push(Text(text.x, text.y, text, 0, options));
  }

  result.push(...PanelNames(panelX, panelY, Scl, options, data.feeder));

  result.push(...drawMainPowerIndicator(panelX, panelY, Scl, options, data.feeder));
  // Panel adları (sol tarafta orta)
  if (data.panelNames && data.panelNames.length > 0) {
    data.panelNames.forEach((name, index) => {
      if (name && name.trim() !== "") {
        textIdCounter++;
        const text = {
          text: name,
          x: panelX - 400 * Scl,
          y: panelY + 20 * Scl + (index * 15 * Scl),
          textHeight: textHeight,
          id: `panel_name_${index}_${textIdCounter}`
        };
        text.handle = text.id;
        result.push(Text(text.x, text.y, text, 0, options));
      }
    });
  }

  // Tip ve güç bilgileri (sağ alt)
  if (data.typeName && data.installedPower) {
    textIdCounter++;
    const tipText = {
      text: `${data.typeName}=${data.installedPower} W`,
      x: panelX + 150 * Scl,
      y: panelY + 100 * Scl,
      textHeight: textHeight,
      id: `panel_type_power_${textIdCounter}`
    };
    tipText.handle = tipText.id;
    result.push(Text(tipText.x, tipText.y, tipText, 0, options));
  }

  if (data.demandPower) {
    textIdCounter++;
    const demandText = {
      text: `${data.demandPower} W`,
      x: panelX + 200 * Scl,
      y: panelY + 115 * Scl,
      textHeight: textHeight,
      id: `panel_demand_${textIdCounter}`
    };
    demandText.handle = demandText.id;
    result.push(Text(demandText.x, demandText.y, demandText, 0, options));
  }

  return result;
}

const branchies2 = [
  {
    breaker: {
      breaker1Curve: "B",
      breaker1notrBreak: false,
      current: 16,
      minBreakerCurrent: 16,
      shortCircuitCurCap: 6
    },
    cable: {
      length: 3,
      material: "Cu",
      section: 2.5,
      type: "NYA"
    },
    phaseCount: 1,
    description: "Priz Linyesi",
    id: "branch-1",
    sorti: 4,
    totalPower: 1200,
    type: "socket"
  },
  {
    breaker: {
      breaker1Curve: "B",
      breaker1notrBreak: false,
      current: 10,
      minBreakerCurrent: 10,
      shortCircuitCurCap: 3
    },
    cable: {
      length: 3,
      material: "Cu",
      section: 2.5,
      type: "NYA"
    },
    phaseCount: 1,
    description: "Aydınlatma Linyesi",
    id: "branch-2",
    sorti: 5,
    totalPower: 90,
    type: "light"
  },
  {
    breaker: {
      breaker1Curve: "B",
      breaker1notrBreak: false,
      current: 20,
      minBreakerCurrent: 20,
      shortCircuitCurCap: 6
    },
    cable: {
      length: 3,
      material: "Cu",
      section: 2.5,
      type: "NYA"
    },
    phaseCount: 1,
    description: "Bulaşık Makinesi",
    id: "branch-3",
    sorti: 1,
    totalPower: 2500,
    type: "socketDish"
  },
  {
    breaker: {
      breaker1Curve: "B",
      breaker1notrBreak: false,
      current: 20,
      minBreakerCurrent: 20,
      shortCircuitCurCap: 6
    },
    cable: {
      length: 3,
      material: "Cu",
      section: 2.5,
      type: "NYA"
    },
    phaseCount: 1,
    description: "Fırın",
    id: "branch-4",
    sorti: 5,
    totalPower: 90,
    type: "socketOven"
  },
  // Yeni makine tipleri örnekleri
  {
    breaker: {
      breaker1Curve: "B",
      breaker1notrBreak: false,
      current: 16,
      minBreakerCurrent: 16,
      shortCircuitCurCap: 6
    },
    cable: {
      length: 3,
      material: "Cu",
      section: 2.5,
      type: "NYA"
    },
    phaseCount: 1,
    description: "Kurutma Makinesi",
    id: "branch-5",
    sorti: 2,
    totalPower: 1800,
    type: "mak"
  },
  {
    breaker: {
      breaker1Curve: "B",
      breaker1notrBreak: false,
      current: 16,
      minBreakerCurrent: 16,
      shortCircuitCurCap: 6
    },
    cable: {
      length: 3,
      material: "Cu",
      section: 2.5,
      type: "NYA"
    },
    phaseCount: 1,
    description: "Buzdolabı",
    id: "branch-6",
    sorti: 1,
    totalPower: 500,
    type: "mak"
  }
]

// Test verisi 


const exampleDataWithTip3 = {
  branchies: branchies2,
  feeder: {
    components: true
  },
  panelNames: ["MUTFAK PANOSİ"],
  typeName: "TIP.3",
  installedPower: "11662",
  demandPower: "6264.8",
  tip3: {
    power: 11662,
    capacity: 6264.8
  },
  protectionRelays: {
    zkt: "Z.K.T.",
    nktCount: 7
  }
};

export const createTekHatSema = (data) => {
  const Scl = 1// 0.5
  // ✅ SIMPLE SUPPLY POINT SAFE DESTRUCTURING
  const {
    branchies = [],     // Default empty array to prevent length errors
    feeder = null       // Default null for safe checking
  } = data || {};       // Safe destructuring with fallback
  let X = 50 * Scl
  let Y = -10 * (branchies.length) - 60 * Scl
  let kolonSemaWidthFac = 200 * Scl

  if (data.x) {
    X = data.x * Scl
    Y = -10 * (branchies.length) - 130 * Scl
    kolonSemaWidthFac = 50 * Scl
  }
  if (data.y) {
       Y -= data.y
  }

  // yOffset parametresi ile doğrudan Y pozisyonu kontrolü
  const yOffset = data.yOffset || 0;

  const phase = 3
  const notrBreaker = false
  //let branchies=branchies4

  if (!Array.isArray(branchies) || branchies.length === 0) {
    return { result: [], width: 0, height: 0 };
  } 
  let result = []
  const layers = {
    0: { name: '0', frozen: false, visible: true, colorIndex: 7, color: 16777215 },
    18: { name: '18', frozen: false, visible: true, colorIndex: 1, color: 16711680 },
    AKSYAZI: { name: 'AKSYAZI', frozen: false, visible: true, colorIndex: 9, color: 12632256 }
  };
  const layer = layers.AKSYAZI
  const options = {
    color: layer.color,
    colorIndex: layer.colorIndex,
    layer: layer.name,
    shape: true,
    hasContinuousLinetypePattern: false
  }

  const offsetOuts = 20 * Scl
  const countOfOut = branchies.length;
  const panoW = 50 * Scl
  const sorti_0_lenght = 130 * Scl
  let panoH = 20 * Scl + countOfOut * 20 * Scl

  let boundingBox = {
    startOffset: 40 * Scl,
    endOffset: 50 * Scl,
    bottomOffset: 80 * Scl,
    topOffset: 30 * Scl,
    width: 600 * Scl,
    height: panoH + sorti_0_lenght
  }

  let currentX = X + boundingBox.startOffset
  X += boundingBox.startOffset
  Y += panoH / 2 + sorti_0_lenght + boundingBox.bottomOffset + 150*Scl +(countOfOut-1)*offsetOuts

  // yOffset ile doğrudan Y pozisyonu ayarla
  Y += yOffset;



  //result.push(PolarLine(X, Y, 0, 2, options))
  Y -= 200 * Scl
  result.push(PolarLine(X, Y, 0, 200 * Scl, options))
  currentX += 212 * Scl

  // Ana sigorta için faz sayısı hesapla
  const mainPhaseCount = calculatePhaseCount(phase, notrBreaker);

  // Ana sigorta çizimi - FAZ SAYISINA GÖRE
  result.push(...AnahtarliOtomatikSigorta(currentX, Y, Scl, mainPhaseCount, 0, options))

  // Ana sigorta bilgilerini ekle - faz bilgisi dahil
 
  const breakerText=feeder.components[1]
  const rcdText=feeder.components[2]
  result.push(...drawBreakerInfo(currentX, Y, breakerText, Scl, options, true, 0, mainPhaseCount));

  currentX += 12 * Scl
  result.push(PolarLine(currentX, Y, 0, 61 * Scl, options))
  currentX += 70 * Scl
  result.push(...KacakAkim(currentX, Y, Scl, 0, options))
  currentX += 9 * Scl
  result.push(PolarLine(currentX, Y, 0, 35 * Scl, options))
  currentX += 60 * Scl
  result.push(...PanoTali(currentX, Y, panoW, panoH, Scl, 0, options))

  //  KOLON ŞEMASI BİLGİLERİNİ ÇİZ
  result.push(...drawColumnSchemaInfo(data, currentX, Y, Scl, options));

  currentX += panoW / 2
  let currentX1 = currentX + 42 * Scl
  let currentY = Y + panoH / 2 - offsetOuts

  boundingBox.width = currentX + countOfOut * 75 * Scl + kolonSemaWidthFac;
  boundingBox.height = panoH + sorti_0_lenght

  const headerHeight = 0 * Scl
  const frameTop = boundingBox.height + boundingBox.bottomOffset + boundingBox.topOffset
  const frameHeight = frameTop + headerHeight
  const frameWidth = boundingBox.width + boundingBox.startOffset + boundingBox.endOffset

  const textHeight = 10 * Scl

  // BASELINE belirleme
  let COMMON_BASELINE_Y = null;

  branchies.forEach((branch, i) => {
    if (COMMON_BASELINE_Y === null) {
      COMMON_BASELINE_Y = currentY - (50 * Scl + (countOfOut - i) * 20 * Scl);
    }

    //  Branch için faz sayısı hesapla
    const branchPhaseCount = calculatePhaseCount(
      branch.phaseCount || 1,
      branch.breaker?.breaker1notrBreak || false
    );

    // Branch numarası
    textIdCounter++;
    let text = {
      text: (i + 1).toString(),
      x: currentX + 10 * Scl,
      y: currentY + 5 * Scl,
      textHeight: textHeight,
      id: `branch_num_${i}_${textIdCounter}`
    }
    text.handle = text.id;

    result.push(PolarLine(currentX, currentY, 0, 30 * Scl, options))

    // ✅ Branch sigorta çizimi - FAZ SAYISINA GÖRE
    result.push(...AnahtarliOtomatikSigorta(currentX1, currentY, Scl, branchPhaseCount, 0, options))

    // ✅ Branch sigorta bilgilerini ekle - faz bilgisi dahil
    result.push(...drawBreakerInfo(currentX1, currentY, branch.breaker, Scl, options, false, i + 1, branchPhaseCount));

    result.push(PolarLine(currentX1 + 12 * Scl, currentY, 0, (countOfOut - i) * 75 * Scl + 150 * Scl, options))
    let curX = currentX1 + 12 * Scl + (countOfOut - i) * 75 * Scl + 150 * Scl

    // Dikey çizgiyi baseline'a kadar çiz
    const verticalLength = currentY - COMMON_BASELINE_Y;
    result.push(PolarLine(curX, currentY, -90, verticalLength, options))
    result.push(Text(text.x, text.y, text, 0, options))

    // Ana yatay hattaki kablo yazısı - kesişim noktasında biter
    const cableText = `${branch.cable.section} mm² ${branch.cable.type}`
    const textWidth = cableText.length * textHeight * 0.6 // Tahmini yazı genişliği
    textIdCounter++;
    text = {
      text: cableText,
      x: curX - textWidth,
      y: currentY + 5 * Scl,
      textHeight: textHeight,
      id: `cable_${i}_${textIdCounter}`
    }
    text.handle = text.id;
    result.push(Text(text.x, text.y, text, 0, options))

    // Baseline alignment ve bağımsız text pozisyonları hesapla
    const alignedSymbolY = getSymbolDrawPosition(COMMON_BASELINE_Y, branch.type, Scl);
    const independentTextPositions = getIndependentTextPositions(COMMON_BASELINE_Y, branch.type, Scl);

    switch (branch.type) {
                  case "socketAirCond":
                  case "socketFan":
                  case "socketMotor":
                  case "socketHidrofor": {
                    // Klima, Fan, Motor, Hidrofor aynı şekilde görünsün
                    let descText = "";
                    if (branch.type === "socketAirCond") descText = "Klima";
                    else if (branch.type === "socketFan") descText = "Fan";
                    else if (branch.type === "socketMotor") descText = "Motor";
                    else if (branch.type === "socketHidrofor") descText = "Hidrofor";
                    const descWidth = descText.length * textHeight * 0.5;
                    textIdCounter++;
                    let descTextObj = {
                      text: descText,
                      x: curX - descWidth / 2,
                      y: independentTextPositions.descY,
                      textHeight: textHeight,
                      id: `${branch.type}_desc_${i}_${textIdCounter}`
                    };
                    descTextObj.handle = descTextObj.id;
                    result.push(...CihazBox(curX, alignedSymbolY+25*Scl, descTextObj, Scl, 0, options));

                    const powerText = `${branch.totalPower} W`;
                    const powerWidth = powerText.length * textHeight * 0.6;
                    textIdCounter++;
                    let powerTextObj = {
                      text: powerText,
                      x: curX - powerWidth / 2,
                      y: independentTextPositions.powerY + 25 * Scl,
                      textHeight: textHeight,
                      id: `${branch.type}_power_${i}_${textIdCounter}`
                    };
                    powerTextObj.handle = powerTextObj.id;
                    result.push(Text(powerTextObj.x, powerTextObj.y, powerTextObj, 0, options));
                    break;
                  }
            case "mak":
              result.push(...Mak(curX, alignedSymbolY, Scl, 0, options));

              const makDescText = branch.description || "Makine";
              const makDescWidth = makDescText.length * textHeight * 0.5;
              textIdCounter++;
              let makDescTextObj = {
                text: makDescText,
                x: curX - makDescWidth / 2,
                y: independentTextPositions.descY,
                textHeight: textHeight,
                id: `mak_desc_${i}_${textIdCounter}`
              };
              makDescTextObj.handle = makDescTextObj.id;
              result.push(Text(makDescTextObj.x, makDescTextObj.y, makDescTextObj, 0, options));

              const makPowerText = `${branch.totalPower} W`;
              const makPowerWidth = makPowerText.length * textHeight * 0.6;
              textIdCounter++;
              let makPowerTextObj = {
                text: makPowerText,
                x: curX - makPowerWidth / 2,
                y: independentTextPositions.powerY,
                textHeight: textHeight,
                id: `mak_power_${i}_${textIdCounter}`
              };
              makPowerTextObj.handle = makPowerTextObj.id;
              result.push(Text(makPowerTextObj.x, makPowerTextObj.y, makPowerTextObj, 0, options));
              break;
      case "light":
        result.push(...Lamba(curX, alignedSymbolY, Scl, 0, options))
        result.push(...Anahtar(curX, currentY, Scl, -40, options))
        result.push(...YuvarlakSolid(curX, currentY, 2.5 * Scl, Scl, options))

        const lightDescText = `${branch.sorti} Ayd.`
        const lightDescWidth = lightDescText.length * textHeight * 0.6
        textIdCounter++;
        let lightDescTextObj = {
          text: lightDescText,
          x: curX - lightDescWidth / 2,
          y: independentTextPositions.descY,
          textHeight: textHeight,
          id: `light_desc_${i}_${textIdCounter}`
        }
        lightDescTextObj.handle = lightDescTextObj.id;
        result.push(Text(lightDescTextObj.x, lightDescTextObj.y, lightDescTextObj, 0, options))

        const lightPowerText = `${branch.totalPower} W`
        const lightPowerWidth = lightPowerText.length * textHeight * 0.6
        textIdCounter++;
        let lightPowerTextObj = {
          text: lightPowerText,
          x: curX - lightPowerWidth / 2,
          y: independentTextPositions.powerY,
          textHeight: textHeight,
          id: `light_power_${i}_${textIdCounter}`
        }
        lightPowerTextObj.handle = lightPowerTextObj.id;
        result.push(Text(lightPowerTextObj.x, lightPowerTextObj.y, lightPowerTextObj, 0, options))

        // Dikey kablo yazıları
        const cable1Text = "2x1.5mm²"
        const cable1Height = cable1Text.length * textHeight * 0.1
        textIdCounter++;
        let cable1TextObj = {
          text: cable1Text,
          x: curX + 5 * Scl,
          y: currentY - cable1Height,
          textHeight: textHeight,
          id: `cable1_${i}_${textIdCounter}`
        }
        cable1TextObj.handle = cable1TextObj.id;
        result.push(Text(cable1TextObj.x, cable1TextObj.y, cable1TextObj, -90, options))

        const cable2Text = "NYA"
        const cable2Height = cable2Text.length * textHeight * 0.8
        textIdCounter++;
        let cable2TextObj = {
          text: cable2Text,
          x: curX + -7 * Scl,
          y: currentY - cable2Height,
          textHeight: textHeight,
          id: `cable2_${i}_${textIdCounter}`
        }
        cable2TextObj.handle = cable2TextObj.id;
        result.push(Text(cable2TextObj.x, cable2TextObj.y, cable2TextObj, -90, options))
        break;

      case "socket":
        result.push(...Priz(curX, alignedSymbolY, Scl, 0, options))

        const socketDescText = `${branch.sorti} Priz`
        const socketDescWidth = socketDescText.length * textHeight * 0.6
        textIdCounter++;
        let socketDescTextObj = {
          text: socketDescText,
          x: curX - socketDescWidth / 2,
          y: independentTextPositions.descY,
          textHeight: textHeight,
          id: `socket_desc_${i}_${textIdCounter}`
        }
        socketDescTextObj.handle = socketDescTextObj.id;
        result.push(Text(socketDescTextObj.x, socketDescTextObj.y, socketDescTextObj, 0, options))

        const socketPowerText = `${branch.totalPower} W`
        const socketPowerWidth = socketPowerText.length * textHeight * 0.6
        textIdCounter++;
        let socketPowerTextObj = {
          text: socketPowerText,
          x: curX - socketPowerWidth / 2,
          y: independentTextPositions.powerY,
          textHeight: textHeight,
          id: `socket_power_${i}_${textIdCounter}`
        }
        socketPowerTextObj.handle = socketPowerTextObj.id;
        result.push(Text(socketPowerTextObj.x, socketPowerTextObj.y, socketPowerTextObj, 0, options))
        break;

      case "socketOven":
        result.push(...Firin(curX, alignedSymbolY, Scl, 0, options))

        const ovenDescText = "Fırın"
        const ovenDescWidth = ovenDescText.length * textHeight * 0.5
        textIdCounter++;
        let ovenDescTextObj = {
          text: ovenDescText,
          x: curX - ovenDescWidth / 2,
          y: independentTextPositions.descY,
          textHeight: textHeight,
          id: `oven_desc_${i}_${textIdCounter}`
        }
        ovenDescTextObj.handle = ovenDescTextObj.id;
        result.push(Text(ovenDescTextObj.x, ovenDescTextObj.y, ovenDescTextObj, 0, options))

        const ovenPowerText = `${branch.totalPower} W`
        const ovenPowerWidth = ovenPowerText.length * textHeight * 0.6
        textIdCounter++;
        let ovenPowerTextObj = {
          text: ovenPowerText,
          x: curX - ovenPowerWidth / 2,
          y: independentTextPositions.powerY,
          textHeight: textHeight,
          id: `oven_power_${i}_${textIdCounter}`
        }
        ovenPowerTextObj.handle = ovenPowerTextObj.id;
        result.push(Text(ovenPowerTextObj.x, ovenPowerTextObj.y, ovenPowerTextObj, 0, options))
        break;

      case "socketDish":
        result.push(...BulasikMak(curX, alignedSymbolY, Scl, 0, options))

        const dishDescText = "BulaşıkM."
        const dishDescWidth = dishDescText.length * textHeight * 0.5
        textIdCounter++;
        let dishDescTextObj = {
          text: dishDescText,
          x: curX - dishDescWidth / 2,
          y: independentTextPositions.descY,
          textHeight: textHeight,
          id: `dish_desc_${i}_${textIdCounter}`
        }
        dishDescTextObj.handle = dishDescTextObj.id;
        result.push(Text(dishDescTextObj.x, dishDescTextObj.y, dishDescTextObj, 0, options))

        const dishPowerText = `${branch.totalPower} W`
        const dishPowerWidth = dishPowerText.length * textHeight * 0.6
        textIdCounter++;
        let dishPowerTextObj = {
          text: dishPowerText,
          x: curX - dishPowerWidth / 2,
          y: independentTextPositions.powerY,
          textHeight: textHeight,
          id: `dish_power_${i}_${textIdCounter}`
        }
        dishPowerTextObj.handle = dishPowerTextObj.id;
        result.push(Text(dishPowerTextObj.x, dishPowerTextObj.y, dishPowerTextObj, 0, options))
        break;

      case "socketWash":
        result.push(...CamasirMak(curX, alignedSymbolY, Scl, 0, options))

        const washDescText = "ÇamaşırM."
        const washDescWidth = washDescText.length * textHeight * 0.5
        textIdCounter++;
        let washDescTextObj = {
          text: washDescText,
          x: curX - washDescWidth / 2,
          y: independentTextPositions.descY,
          textHeight: textHeight,
          id: `wash_desc_${i}_${textIdCounter}`
        }
        washDescTextObj.handle = washDescTextObj.id;
        result.push(Text(washDescTextObj.x, washDescTextObj.y, washDescTextObj, 0, options))

        const washPowerText = `${branch.totalPower} W`
        const washPowerWidth = washPowerText.length * textHeight * 0.6
        textIdCounter++;
        let washPowerTextObj = {
          text: washPowerText,
          x: curX - washPowerWidth / 2,
          y: independentTextPositions.powerY,
          textHeight: textHeight,
          id: `wash_power_${i}_${textIdCounter}`
        }
        washPowerTextObj.handle = washPowerTextObj.id;
        result.push(Text(washPowerTextObj.x, washPowerTextObj.y, washPowerTextObj, 0, options))
        break;

      case "socketCombi":
        const combiDescText = "Kombi"
        const combiDescWidth = combiDescText.length * textHeight * 0.5
        textIdCounter++;
        let combiDescTextObj = {
          text: combiDescText,
          x: curX - combiDescWidth / 2,
          y: independentTextPositions.descY-10*Scl+25*Scl,
          textHeight: textHeight,
          id: `combi_desc_${i}_${textIdCounter}`
        }
        combiDescTextObj.handle = combiDescTextObj.id;
        result.push(...CihazBox(curX, alignedSymbolY+25*Scl ,combiDescTextObj, Scl, 0, options))


 
        const combiPowerText = `${branch.totalPower} W`
        const combiPowerWidth = combiPowerText.length * textHeight * 0.6
        textIdCounter++;
        let combiPowerTextObj = {
          text: combiPowerText,
          x: curX - combiPowerWidth / 2,
          y: independentTextPositions.powerY,
          textHeight: textHeight,
          id: `combi_power_${i}_${textIdCounter}`
        }
        combiPowerTextObj.handle = combiPowerTextObj.id;
        result.push(Text(combiPowerTextObj.x, combiPowerTextObj.y+25*Scl, combiPowerTextObj, 0, options))
        break;
  
        case "lowCurrent":
              textIdCounter++;
    let lowCurrentTextObj = {
      text: "ZİL",
      textHeight: textHeight,
      handle: `lowCurrent_symbol_${i}_${textIdCounter}`,
      id: `lowCurrent_symbol_${i}_${textIdCounter}`
    }
        result.push(...CihazBox(curX, alignedSymbolY,lowCurrentTextObj, Scl, 0, options))

         const lowCurrentPowerText = `${branch.totalPower} W`
        const lowCurrentPowerWidth = lowCurrentPowerText.length * textHeight * 0.6
        textIdCounter++;
        let lowCurrentPowerTextObj = {
          text: lowCurrentPowerText,
          x: curX - lowCurrentPowerWidth / 2,
          y: independentTextPositions.powerY+20*Scl,
          textHeight: textHeight,
          id: `lowCurrent_power_${i}_${textIdCounter}`
        }
        lowCurrentPowerTextObj.handle = lowCurrentPowerTextObj.id;
        result.push(Text(lowCurrentPowerTextObj.x, lowCurrentPowerTextObj.y, lowCurrentPowerTextObj, 0, options))  

        break;
        


      }

    currentY -= offsetOuts
  });

  return { result: result, width: frameWidth, height: frameHeight };
};

// Dosyanın sonunda
export const TEK_HAT_BASE_DATA = exampleDataWithTip3;
 